import { toast } from 'react-toastify';

import { AppThunkDispatch } from '@Reducers/index';

import { AccessControlApiService, ICreateAccessControlListModel } from '@ClientApi/accessControlApi';
import { IAccessControlListModel } from '@Shared/models';

export const SET_ACLS = 'SET_ACLS';
export const SET_GROUPED_ACLS_BY_USER = 'SET_GROUPED_ACLS_BY_USER';

export class SetAcls {
  readonly type = SET_ACLS;
  readonly payload: IAccessControlListModel[];

  constructor(acls: IAccessControlListModel[]) {
    this.payload = acls;
  }
}

export class SetGroupedAccessControlLists {
  readonly type = SET_GROUPED_ACLS_BY_USER;
  readonly payload: any;

  constructor(allAccessControlLists: any) {
    this.payload = allAccessControlLists;
  }
}

export const getAcls = () => async (dispatch: AppThunkDispatch) => {
  const acls = await AccessControlApiService.get();
  dispatch(new SetAcls(acls));
};

export const getAllAccessControlLists = () => async (dispatch: AppThunkDispatch) => {
  const allAccessControlLists = await AccessControlApiService.getGroupedAccessControlLists();
  dispatch(new SetGroupedAccessControlLists(allAccessControlLists));
};
export const createAcl =
  (acl: ICreateAccessControlListModel, AbacusDataManager?: any, isApprovalSetting?: boolean) => async (dispatch: AppThunkDispatch) => {
    const acls = await AccessControlApiService.create(acl);
    if (isApprovalSetting) {
      toast.success('Updated approval settings');
    }

    if (AbacusDataManager) {
      // It's not very nice, but this method will dispatch the actual SetAcls action
      // Since several Angular pages are subscribed to access_control_lists, the data needs to go through the manager (for now)
      AbacusDataManager.methods.access_control_lists.set(acls);
    } else {
      dispatch(new SetAcls(acls));
    }
  };

export const deleteAcl = (id: string, AbacusDataManager?: any, isApprovalSetting?: boolean) => async (dispatch: AppThunkDispatch) => {
  const acls = await AccessControlApiService.delete(id);
  if (isApprovalSetting) {
    toast.success('Updated approval settings');
  }

  if (AbacusDataManager) {
    // It's not very nice, but this method will dispatch the actual SetAcls action
    // Since several Angular pages are subscribed to access_control_lists, the data needs to go through the manager (for now)
    AbacusDataManager?.methods.access_control_lists.set(acls);
  } else {
    dispatch(new SetAcls(acls));
  }
};

export type AccessControlAction = SetAcls | SetGroupedAccessControlLists;
